const i18n = {
  'profile': {
    'title': '個人資料',
    'tags': '標籤',
    'selectPhoto': '從裝置中選擇一張照片',
    'name': '姓名',
    'gender': '性別',
    'birthday': '生日',
    'job': '身份',
    'interest': '興趣',
    'skill': '專長',
    'wantingToLearn': '我想學',
    'contacts': '聯絡方式',
    'addContact': '新增聯絡方式',
    'contactData': '聯絡資料',
    'option': {
      'gender': {
        'male': '男',
        'female': '女'
      }
    }
  }
};
export default i18n;
